module.exports = __webpack_public_path__ + "img/logo.691e0127.png";